import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { isNumber } from 'lodash';
import HistoryLogsWrapper from '../history-logs-wrapper';
import MoneyDisplay from '../money-display';
import DateTimeDisplay from '../date-time-display';
import { getColorFromKey } from '../../util/helpers';

class LogRenderer extends Component {
  renderStage() {
    const { value } = this.props;
    const color = getColorFromKey(value);
    return <span style={{ color }}>{value}</span>;
  }
  renderComp() {
    const { value, field, data } = this.props;
    let comp = null;
    if (value && data) {
      if (field === 'amount') {
        let val = value;
        if (!isNumber(val)) {
          val = val.value;
        }
        comp = (
          <MoneyDisplay currencyIsoCode={data.currency_iso_code} baseValue={data.base_amount} value={val} precision={2} abbreviated />
        );
      } else if (field === 'close_date') {
        comp = (
          <DateTimeDisplay value={value} format="short" />
        );
      } else if (field === 'stage') {
        comp = this.renderStage();
      } else {
        comp = (
          <span>{value}</span>
        );
      }
    }

    return comp;
  }

  render() {
    const { data, field, logField } = this.props;

    const isGrouped = this.props.node && this.props.node.group;

    const comp = this.renderComp();

    if (!isGrouped && data && data.opportunity_id) {
      return (
        <div>
          <HistoryLogsWrapper type={(logField || field)} opportunity={data}>
            {comp}
          </HistoryLogsWrapper>
        </div>
      );
    }
    return comp;
  }
}

LogRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(moment),
    PropTypes.shape({
      value: PropTypes.number,
    }),
  ]),
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
  field: PropTypes.string.isRequired,
  logField: PropTypes.string,
};
LogRenderer.defaultProps = {
  value: null,
  data: null,
  node: null,
  logField: null,
};

export default LogRenderer;
